module.exports = __webpack_public_path__ + "img/nick-konechny.7c46ae75.jpg";